import { createContext, useContext } from 'react';
import { PAGE_TYPES } from 'Src/constants';
import { IServerDataType } from 'Src/store/context/types';
// TODO после унификации формата в коллекциях убрать Omit
export const AppContext = createContext<Omit<IServerDataType, 'data'>>({
    page_type: PAGE_TYPES.index,
    page_data: {},
    layout: {
        menu: [],
        custom: {
            isMobile: false,
            project_name: '',
            next_articles: [],
        },
        domain: '',
        var: {
            sitezone: 0,
            siteid: 0,
            pets: '',
        },
        head: {
            csrf: {
                token: '',
            },
            link: [],
            meta: [],
            title: '',
        },
        user: {
            user_id: null,
            menu_links: [],
            pets: {
                object_list: [],
                urls: {
                    add: '',
                },
            },
        },
        urls: {
            canonical: '',
        },
        api: {
            feedback: {
                method: 'GET',
                url: '',
            },
        },
        rb: {
            site_id: '',
            sitezone: '',
            entity_id: '',
            entity_type: '',
            entity_content_subtype: '',
            entity_type_id: 0,
            project_id: 0,
            project_uuid: '',
        },
        seo: {
            jsonld: {},
        },
    },
});
export const useAppContext = () => useContext(AppContext);
export const { Provider: AppContextProvider } = AppContext;
